import script from "./CookieBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./CookieBanner.vue?vue&type=script&setup=true&lang=ts"

import "./CookieBanner.vue?vue&type=style&index=0&id=669cbfb8&lang=scss"

const __exports__ = script;

export default __exports__